import { Box, TextField, Typography } from '@mui/material';

import { labelSx } from './styles';

interface CredTextareaProps {
  label: string;
  name: string;
  value?: string;
  onChange: (name: string, value: string) => void;
  helperText?: string;
  disabled?: boolean;
  minRows?: number;
  maxRows?: number;
  placeholder?: string;
  monospace?: boolean;
  maxWidth?: number;
}

/** Reusable textarea field for JSON, SSH keys, etc. */
export const CredTextarea = ({
  label,
  name,
  value,
  onChange,
  helperText,
  disabled = false,
  minRows = 8,
  maxRows = 16,
  placeholder,
  monospace = true,
  maxWidth = 500,
}: CredTextareaProps) => (
  <Box sx={{ mb: 1.5 }}>
    <Typography sx={labelSx}>{label}</Typography>
    <TextField
      name={name}
      value={value || ''}
      onChange={(e) => onChange(name, e.target.value)}
      multiline
      minRows={minRows}
      maxRows={maxRows}
      size="small"
      disabled={disabled}
      placeholder={placeholder}
      sx={{
        width: '100%',
        maxWidth,
        '& .MuiInputBase-input': {
          fontFamily: monospace ? 'monospace' : 'inherit',
          fontSize: '12px',
          lineHeight: 1.4,
        },
        '& .MuiOutlinedInput-root': {
          borderRadius: '4px',
        },
      }}
    />
    {helperText && (
      <Typography sx={{ fontSize: '11px', color: '#888', mt: 0.25 }}>{helperText}</Typography>
    )}
  </Box>
);
